import React, { useState } from 'react';
import './BookingSystem.css';
import CommProfileHeader from '../../../Exhibitor/Profile/CommProfileHeader';
import MyMeetingRequestList from '../MyMeetingRequest/MyMeetingRequestList';
import MeetingBooking from '../MyMeetingRequest/MeetingBooking';
import { B2BAuthContext } from '../../../../Context/AuthContex/B2BAuthContext';
import { useSearchParams } from 'react-router-dom';

const BookingSystem: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isBook = searchParams.get('isBook');
  const [toggle, setToggle] = useState<boolean>(isBook ? true : false);
  const {
    state: { b2bUser },
  } = B2BAuthContext();

  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add Meeting Request`}
        listHeadingTitle='My Meeting Request List'
        createBtnText='Create Meeting Request'
        toggle={toggle}
        setToggle={(e) => {
          setToggle(e);
          if (e) {
            setSearchParams({ isBook: 'booking' });
          } else {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('isBook');
            setSearchParams(newSearchParams);
          }
        }}
      />
      {toggle ? (
        <MeetingBooking type='B2B' user_id={b2bUser.b2b_id as number} />
      ) : (
        <MyMeetingRequestList type='B2B' user_id={b2bUser.b2b_id as number} />
      )}
    </>
  );
};

export default BookingSystem;
